import React from "react";
import {
  Grid,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Divider,
  Box,
  Checkbox,
  FormControlLabel,
} from "@mui/material";
import { ContactTypes } from "../../models/ContactTypes";

function SectionHeading({ title }) {
  return (
    <Box mb={1.5}>
      <Typography variant="subtitle2" color="primary" fontWeight={600} gutterBottom>
        {title}
      </Typography>
      <Divider />
    </Box>
  );
}

export default function BillingTab({ formData, handleChange, setFormData }) {
  return (
    <Box display="flex" flexDirection="column" gap={3}>

      {/* ── Address Section ──────────────────────────────────────────── */}
      <Box>
        <SectionHeading title="Address" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Billing Name" name="billingName"
              value={formData.billingName || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Address" name="billingAddress"
              value={formData.billingAddress || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Address 2" name="billingAddress2"
              value={formData.billingAddress2 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="City" name="billingCity"
              value={formData.billingCity || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="State" name="billingState"
              value={formData.billingState || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Zip" name="billingZip"
              value={formData.billingZip || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Country" name="billingCountry"
              value={formData.billingCountry || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
        </Grid>
      </Box>

      {/* ── Contact Section ──────────────────────────────────────────── */}
      <Box>
        <SectionHeading title="Contact" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Phone 1 Type</InputLabel>
              <Select name="billingPhone1Type"
                value={formData.billingPhone1Type || ""}
                onChange={handleChange} label="Phone 1 Type">
                {Object.entries(ContactTypes).map(([key, { text, value }]) => (
                  <MenuItem key={key} value={value}>{text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Phone 1" name="billingPhone1"
              value={formData.billingPhone1 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControl fullWidth size="small">
              <InputLabel>Phone 2 Type</InputLabel>
              <Select name="billingPhone2Type"
                value={formData.billingPhone2Type || ""}
                onChange={handleChange} label="Phone 2 Type">
                {Object.entries(ContactTypes).map(([key, { text, value }]) => (
                  <MenuItem key={key} value={value}>{text}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Phone 2" name="billingPhone2"
              value={formData.billingPhone2 || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>

          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Contact Person" name="billingContact"
              value={formData.billingContact || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Email" name="billingEmail"
              value={formData.billingEmail || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <TextField label="Fax" name="billingFax"
              value={formData.billingFax || ""} onChange={handleChange}
              fullWidth size="small" />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
        </Grid>
      </Box>

      {/* ── Preferences Section ──────────────────────────────────────── */}
      <Box>
        <SectionHeading title="Preferences" />
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}>
            <FormControlLabel
              control={
                <Checkbox
                  checked={formData.shouldReceiveCoC || false}
                  onChange={(e) =>
                    setFormData({ ...formData, shouldReceiveCoC: e.target.checked })
                  }
                  name="shouldReceiveCoC"
                />
              }
              label="Receive CoC with Invoice"
            />
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
          <Grid size={{ xs: 12, sm: 6, md: 3 }}/>
        </Grid>
      </Box>

    </Box>
  );
}